/**
 * Credentials control module
 */
import { formatDateUtil, parseDate } from "../../../utils/dateFnsUtils";
import { requestData } from "./utils";
export default class Credentials {
  // constructor() {}
  add(api_key, credential) {
    //try to format the date
    let date = null;
    if (credential.valid_until) {

      const formattedRegex = new RegExp(/^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) 00:00:00$/gm);
      const isFormatted = formattedRegex.test(credential.valid_until);

      date = isFormatted ? credential.valid_until : formatDateUtil(
        parseDate(credential.valid_until, "MM/dd/yyyy"),
        "yyyy-MM-dd HH:mm:ss"
      );
      credential.valid_until = date;
    }

    return requestData("POST", `/api_key_credential/${api_key}`, {
      credential,
    });
  }
  get(api_key, credential_id) {
    return requestData("GET", `/api_key_credential/${api_key}/${credential_id}`);
  }
  update(api_key, credential_id, credential) {
    let date = null;
    if (credential.valid_until_date) {

      const formattedRegex = new RegExp(/^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) 00:00:00$/gm);
      const isFormatted = formattedRegex.test(credential.valid_until_date);

      date = isFormatted ? credential.valid_until_date : formatDateUtil(
        parseDate(credential.valid_until_date, "MM/dd/yyyy"),
        "yyyy-MM-dd HH:mm:ss"
      );
      credential.valid_until_date = date;
    }
    return requestData("PUT", `/api_key_credential/${api_key}/${credential_id}`, {credential});
  }
  delete(api_key, credential_id) {
    return requestData("DELETE", `/api_key_credential/${api_key}/${credential_id}`);
  }
}
